export enum CommentLevels {
    FIRST = 1,
    SECOND = 2,
    THIRD = 3,
}

export enum ReactionTypes {
    LIKE = 'like',
}